<div class="wrapper">
  <div class="stars" [ngClass]="{'selected': x <= focusedIndex}"
    *ngFor="let a of maxArray; let x = index;" (click)="onSelected(x)" (mouseover)="mouseover(x)"  (mouseout)="mouseout(x)">
    <span class="value">{{x + 1}}</span>
  </div>
</div>
